export const getCostAvoidedValue = (
  costAvoidedAI,
  costSavingSettings,
  equipmentLaborSaving,
  lphAvoided,
  downtimeAvoided,
  downtimeType,
) => {
  if (!Object.keys(costSavingSettings).length) {
    return costAvoidedAI;
  }
  let costAvoidedValue = parseFloat(equipmentLaborSaving || 0);
  let avoidedType = +costSavingSettings.use_lph_avoided ? +lphAvoided : +downtimeAvoided;
  const multiplicationFactor =
    costSavingSettings.multiplication_factor_in_currency ?? costSavingSettings.multiplication_factor;

  if (+downtimeType === 1) {
    avoidedType = avoidedType / 60;
  }

  if (avoidedType >= +costSavingSettings.min_value) {
    costAvoidedValue += parseFloat(multiplicationFactor) * parseFloat(avoidedType || 0);
  }


  return costAvoidedValue;
};
